/**
 * Bridge 模块
 *
 * 使用 @chieftrade/chief-bridge npm 包，不再 new 旧共享库的 ChiefBridge。
 * - 页面交互走 bridge.send()；unauthorized / showToast / startAppLoading / stopAppLoading 为内置方法
 * - 请求库（libs/http-client）的 401 无感刷新也走本实例
 * - 环境判断（isEmbedded / shouldUseAppLoading 等）仍来自 src/libs/chief-bridge
 */
import {
  createBridgeClient,
  type BridgeClient,
} from "@chieftrade/chief-bridge";
import { createTypedDatafinderSender } from "../../libs/datafinder";

/** H5 发送给 Native 的消息 */
export interface OutgoingEvents {
  Route_HomePage: void;
  share: {
    title: string;
    shareContentText: string;
  };
  openLink: {
    linkType: number;
    linkUrl: string;
    aosLinkUrl?: string;
  };
  /** 发送标题给 App */
  Send_Title_To_App: {
    title: string;
  };
  /** 火山埋点，站内转发给 Native 上报 */
  sendDatafinder: {
    eventName: string;
    params: Record<string, string>;
  };
}

/** Native 发送给 H5 的消息 */
interface IncomingEvents {
  /** App 静默刷新 Token 完成（新 Token 已写入 localStorage），只作信号，不带 payload */
  tokenRefreshed: void;
}

/**
 * project 沿用旧实例的 "lottery-anniversary"，保证 Native 侧识别不变；
 * outgoingProtocol: "array" 表示 payload 包成 [data]，与旧 ChiefBridge.callNative 格式一致
 */
export const bridge: BridgeClient<OutgoingEvents, IncomingEvents> =
  createBridgeClient<OutgoingEvents, IncomingEvents>({
    project: "lottery-anniversary",
    outgoingProtocol: "array",
    incomingProtocol: "direct",
  });

/** 发送 DataFinder 埋点：站内发事件给 Native，站外走 H5 SDK（实现见 src/libs/datafinder.ts） */
export const sendDatafinder = createTypedDatafinderSender((eventName, params) =>
  bridge.send("sendDatafinder", { eventName, params }),
);
